import { generateSecureRandomPart } from "@/lib/utils/common-utils";
import { getCookieValue } from "@/utils/cookieUtils";
import { parse } from "cookie";
import { NextApiRequest } from "next";

/**
 * Extract backend traceId from request cookies or headers
 */
export const getBackendTraceId = (req?: NextApiRequest): string | null => {
  try {
    if (req?.cookies?.traceId_QRV) {
      return req.cookies.traceId_QRV;
    }

    if (req?.headers?.cookie) {
      const cookies = parse(req.headers.cookie);
      return cookies["traceId_QRV"] ?? null;
    }
    return null;
  } catch(err) {
    console.error("Error extracting traceId_QRV from request:", err);
    return null;
  }
};

/**
 * Generates a unique correlationId per request
 */
export const generateCorrelationId = (): string => {
  const timestamp = Date.now().toString().slice(-8);
  const randomPart = generateSecureRandomPart();
  return `C${timestamp}${randomPart}`;
};

/**
 * Builds common tracing headers
 */
export const buildTraceHeaders = (
  req?: NextApiRequest
): Record<string, string> => ({
  "x-trace-id": getBackendTraceId(req) ?? getCookieValue("traceId_QRV") ?? "TRACE_NOT_FOUND",
  "x-correlation-id": generateCorrelationId(),
});
